"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.____VarRef = void 0;
const __1 = require("..");
class ____VarRef extends __1.EL {
    tag = "____VarRef";
    get isControl() { return true; }
    attr;
    refSentenceTextRangeCache = null;
    get refSentenceTextRange() {
        if (this.refSentenceTextRangeCache !== null && this.refSentenceTextRangeCache[0] === this.attr.refSentenceTextRange) {
            return this.refSentenceTextRangeCache[1];
        }
        else {
            const refSentenceTextRange = JSON.parse(this.attr.refSentenceTextRange);
            this.refSentenceTextRangeCache = [this.attr.refSentenceTextRange, refSentenceTextRange];
            return refSentenceTextRange;
        }
    }
    constructor(options) {
        super("____VarRef", {}, [], options.range);
        const { refName, declarationID, refSentenceTextRange } = options;
        this.attr = {
            refName,
            declarationID,
            refSentenceTextRange: JSON.stringify(refSentenceTextRange),
        };
        this.children.push(refName);
    }
}
exports.____VarRef = ____VarRef;
//# sourceMappingURL=varRef.js.map